import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class AppoggioService {

    fromMobile = false;
    codiceForm = null;
    coloriIframe = null;

    constructor(private http: HttpClient) { }

    setFromMobile(value) {
        this.fromMobile = value;
    }

    getFromMobile() {
        return this.fromMobile;
    }

    setCodiceForm(value) {
        this.codiceForm = value;
    }

    getCodiceForm() {
        return this.codiceForm;
    }

    setColoriIframe(cantina) {
        this.coloriIframe = {
            testo: cantina['testo'],
            sfondo: cantina['sfondo'],
            sfondoBtnPrimario: cantina['sfondoBtnPrimario'],
            coloreBtnPrimario: cantina['coloreBtnPrimario'],
            sfondoBtnSecondario: cantina['sfondoBtnSecondario'],
            coloreBtnSecondario: cantina['coloreBtnSecondario'],
            sfondoBtnPrimarioHover: cantina['sfondoBtnPrimarioHover'],
            coloreBtnPrimarioHover: cantina['coloreBtnPrimarioHover'],
            sfondoBtnSecondarioHover: cantina['sfondoBtnSecondarioHover'],
            coloreBtnSecondarioHover: cantina['coloreBtnSecondarioHover'],
            coloreBold: cantina['coloreBold'],
            sfondoBtnItems: cantina['sfondoBtnItems'],
            coloreBtnItems: cantina['coloreBtnItems'],
            sfondoBtnItemsHover: cantina['sfondoBtnItemsHover'],
            coloreBtnItemsHover: cantina['coloreBtnItemsHover'],
            sfondoCardItems: cantina['sfondoCardItems'],
            sfondoHeader: cantina['sfondoHeader'],
            coloreHeader: cantina['coloreHeader'],
            font: cantina['font']
        }
    }

    getColoriIframe() {
        return this.coloriIframe;
    }
}
